export const VALID_GUESSES = [
  'addax',

  'akita',

  'aguti',

  'ammon',

  'anoas',

  'bears',

  'boars',

  'birds',

  'bison',

  'bitch',

  'bongo',

  'bobac',

  'booby',

  'brock',

  'bruin',

  'burro',

  'bulls',

  'camel',

  'canis',

  'chimp',

  'chiru',

  'civet',

  'chics',

  'coati',

  'cobra',

  'coney',

  'coypu',

  'crone',

  'crane',

  'crabs',

  'crows',

  'cuddy',

  'chick',

  'daman',

  'dhole',

  'dingo',

  'drill',

  'ducks',

  'doves',

  'eland',

  'eagle',

  'egret',

  'fowls',

  'foxes',

  'foals',

  'filly',

  'fitch',

  'fossa',

  'frogs',

  'gayal',

  'gaurs',

  'genet',

  'goral',

  'goats',

  'goose',

  'geese',

  'grice',

  'gryce',

  'gulls',

  'hinny',

  'heron',

  'hippo',

  'horse',

  'hutia',

  'hyena',

  'hyrax',

  'indri',

  'izard',

  'jocko',

  'kaama',

  'kiwis',

  'kiang',

  'koala',

  'kulan',

  'kudus',

  'kyloe',

  'lambs',

  'lemur',

  'liger',

  'loons',

  'lions',

  'llama',

  'loris',

  'mules',

  'macaw',

  'magot',

  'manis',

  'manul',

  'mhorr',

  'moose',

  'morse',

  'mouse',

  'nagor',

  'nyala',

  'okapi',

  'orang',

  'oribi',

  'otary',

  'orcas',

  'otter',

  'ounce',

  'panda',

  'pekan',

  'phoca',

  'pongo',

  'potto',

  'puppy',

  'quail',

  'quoll',

  'ratel',

  'rhino',

  'royal',

  'sable',

  'saiga',

  'sajou',

  'sasin',

  'serow',

  'seals',

  'swans',

  'sheep',

  'shoat',

  'shote',

  'shrew',

  'skunk',

  'sloth',

  'sorel',

  'spado',

  'steer',

  'stirk',

  'stoat',

  'swine',

  'snake',

  'toads',

  'tabby',

  'takin',

  'tapir',

  'tatou',

  'tahar',

  'tiger',

  'tigon',

  'tunas',

  'urial',

  'urson',

  'vison',

  'vixen',

  'viper',

  'worms',

  'whale',

  'whelp',

  'wrens',

  'zebra',

  'billy',

  'roach',

  'mcnab',

  'moths',

  'kerry',

  'jindo',

  'alano',

  'irish',

  'husky',

  'cesky',

  'plott',

  'corgi',

  'boxer',

  'dwelf',

  'lykoi',

  'shiba',

  'spitz',

  'silky',

  'korat',

  'lykoi',

  'asian',

  'satyr',

  'queen',

  'larva',

  'aphid',

  'drone',

  'midge',

  'musca',

  'imago',

  'aphis',

  'snail',

  'oubit',

  'louse',

  'midge',

  'oobit',

  'leech',

  'gecko',

  'robin',

  'finch',

  'oxeye',

  'mynah',

  'noddy',

  'ousel',

  'stork',

  'pipit',

  'scaup',

  'stilt',

  'stork',

  'snipe',

  'stilt',

  'brant',

  'crake',

  'diver',

  'junco',

  'merle',

  'miner',

  'munia',

  'twite',

  'flies',

  'wasps',

  'worms',

  'shark',
]
